// extracted by mini-css-extract-plugin
export default {"main":"ResourceCentre_main__QpXHY","heading":"ResourceCentre_heading__6VvoM"};